import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DrawerHost } from '@shared/components/drawer-host/drawer-host';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, DrawerHost, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('Sinhantb');
}
